var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 10.2231C20.0108 9.53538 19.9382 8.84765 19.785 8.17969H10.2031V11.891H15.8288C15.6151 13.2072 14.861 14.3771 13.7439 15.136L13.7237 15.2585L16.7523 17.5589L16.962 17.5786C18.8857 15.8356 19.9987 13.2704 19.9987 10.2231Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2029 19.9962C12.9573 19.9962 15.2721 19.1069 16.9618 17.5733L13.7437 15.1268C12.6992 15.8145 11.4611 16.1623 10.2069 16.1267C7.56145 16.1109 5.22245 14.4351 4.39976 11.9688L4.27878 11.9806L1.12919 14.3679L1.08887 14.4786C2.81489 17.8658 6.34355 20.0001 10.2029 19.9962Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39571 11.9785C4.17391 11.3422 4.05696 10.6742 4.05696 9.99835C4.06099 9.32643 4.17391 8.65847 4.38765 8.01817L4.38361 7.88774L1.1937 5.46094L1.08885 5.50836C-0.362949 8.33437 -0.362949 11.6623 1.08885 14.4883L4.39571 11.9785Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2029 3.86609C11.6668 3.84238 13.0783 4.37596 14.147 5.35617L17.0264 2.60131C15.1793 0.901758 12.7315 -0.0270664 10.1989 0.00060078C6.33953 0.00060078 2.81087 2.13097 1.08081 5.51427L4.37961 8.02407C5.21036 5.55774 7.55339 3.8819 10.2029 3.86609Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon01);
export default __webpack_public_path__ + "static/media/login-icon-01.e6adaf1a6e692d8d6f9c619a2fa7872a.svg";
export { ForwardRef as ReactComponent };